import { PaginationBar } from "@components/PaginationBar";
import { ItemCardV2 } from "@components/item/ItemCardV2";
import { useApi } from "@hooks/ApiHook";
import { CollectionResponse } from "baaanggg";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { resolveImageUrl } from "@helpers/image.helper";

export interface Props {
    collection: CollectionResponse,
    address: string
}

export function formatTimeAgo(date: Date) {
    const now = new Date();
    const diffInMillis = now.getTime() - new Date(date.toString()).getTime()

    const minutes = Math.floor(diffInMillis / 60000);
    const hours = Math.floor(minutes / 60);

    if (hours >= 1) {
        return `${hours} Hours ${minutes % 60} Minutes Ago`;
    } else {
        return `${minutes} Minutes Ago`;
    }
}

export default function BidsTab({ collection, address }: Props) {
    const [page, setPage] = useState(1)
    const { data: paginatedBids } = useApi(api => api.transaction.bids({ collectionId: collection.id, ownerAddress: address, page: page }), [collection, page, address])


    return <div>
        <div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:px-40">
            {
                paginatedBids?.data.filter(tx => tx.ownerAddress === tx.nft?.ownerAddress).map(tx => {

                    return <Link to={`/nft/${tx.collectionAddress}/${tx.tokenId}`}
                        className="relative flex items-center rounded-2.5xl border border-jacarta-100 bg-white p-8 transition-shadow hover:shadow-lg dark:border-gray-400 dark:bg-gray-900">
                        <figure className="mr-5 self-start">
                            <img src={resolveImageUrl(tx.nft?.image)} alt="item 3" className="rounded-2lg w-12 h-12`" loading="lazy" />
                        </figure>

                        <div>
                            <h3 className="mb-1 font-display text-base font-semibold text-jacarta-700 dark:text-white">
                                {tx.nft?.name}
                            </h3>
                            <span className="mb-3 block text-sm text-jacarta-500 dark:text-gray-400">
                                bid by {tx.bid?.buyerAddress.substring(0, 7)}...{tx.bid?.buyerAddress.substring(tx.bid.buyerAddress.length - 5)}
                            </span>
                            <span className="block text-xs text-white">
                                {formatTimeAgo(tx.createdAt)}
                            </span>
                        </div>

                        <div className="ml-auto rounded-full border border-jacarta-100 p-3 dark:border-gray-400">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                className="fill-jacarta-700 dark:fill-white">
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path
                                    d="M14 20v2H2v-2h12zM14.586.686l7.778 7.778L20.95 9.88l-1.06-.354L17.413 12l5.657 5.657-1.414 1.414L16 13.414l-2.404 2.404.283 1.132-1.415 1.414-7.778-7.778 1.415-1.414 1.13.282 6.294-6.293-.353-1.06L14.586.686zm.707 3.536l-7.071 7.07 3.535 3.536 7.071-7.07-3.535-3.536z" />
                            </svg>
                        </div>
                    </Link>
                })
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedBids && <PaginationBar
                pagination={paginatedBids}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}